import { render, staticRenderFns } from "./ProformaSummary.vue?vue&type=template&id=634ae37f&"
import script from "./ProformaSummary.vue?vue&type=script&lang=js&"
export * from "./ProformaSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProformaSummary.vue?vue&type=style&index=0&id=634ae37f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports